<template>
    <div class="admin-content">
        <LoadingPlaceholder v-if="!loaded" />
        <template v-if="loaded">
            <div>
                <a @click.prevent="$emit('change-page', { page: 'AdminPage' })" :href="adminSitesUrl" class="back-link icon icon-arrow-left">Sites</a>
            </div>
            <h1 class="admin-content-heading">Widgets</h1>
            <div class="form-group">
                <h2 class="d-inline-block">Search</h2>
                <a :href="searchUrl" class="widget-link" target="_blank">Demo</a>
                <div class="card card-body bg-light code-card">
                    <code>
                        {{ searchWidgetCode }}
                    </code>
                </div>
            </div>
            <div class="form-group">
                <h2 class="d-inline-block">Guided Search</h2>
                <a :href="guidedSearchUrl" class="widget-link" target="_blank">Demo</a>
                <div class="card card-body bg-light code-card">
                    <code>
                        {{ guidedSearchWidgetCode }}
                    </code>
                </div>
            </div>
            <div class="form-group">
                <h2 class="d-inline-block">Directory</h2>
                <a :href="directoryUrl" class="widget-link" target="_blank">Demo</a>
                <div class="card card-body bg-light code-card">
                    <code>
                        {{ directoryWidgetCode }}
                    </code>
                </div>
            </div>
            <div class="form-group" v-if="showMyFormsWidget">
                <h2 class="d-inline-block">My Forms</h2>
                <a :href="myFormsUrl" class="widget-link" target="_blank">Demo</a>
                <div class="card card-body bg-light code-card">
                    <code>
                        {{ myFormsWidgetCode }}
                    </code>
                </div>
            </div>
        </template>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref, onActivated, onBeforeMount } from "vue";
import { useMainStore } from "@/mainStore";
import LoadingPlaceholder from "@/lib/LoadingPlaceholder.3.vue";
import getData from "../../lib/getData";
import { computedAsync } from "@vueuse/core";
export default defineComponent({
    props: ["settings"],
    setup(props) {
        const mainStore = useMainStore();
        const searchWidgetCode = ref<string | null>(null);
        const directoryWidgetCode = ref<string | null>(null);
        const guidedSearchWidgetCode = ref<string | null>(null);
        const myFormsWidgetCode = ref<string | null>(null);
        const showMyFormsWidget = ref<boolean>(false);
        const loaded = ref<boolean>(true);
        const isInitialCreate = ref<boolean>(true);

        const getUrlPromise = (widget: string) => {
            return mainStore.getUrl("adminWidgetTest", { widget: widget, tenantUrlSlug: props.settings.areaUrlSlug, tenantCode: props.settings.areaCode });
        };

        const adminUrl = computedAsync(() => {
            return mainStore.getUrl("admin");
        });
        const adminSitesUrl = computedAsync(() => {
            return getUrlPromise("AdminPage");
        });
        const guidedSearchUrl = computedAsync(() => {
            return getUrlPromise("GuidedSearch");
        });
        const searchUrl = computedAsync(() => {
            return getUrlPromise("Search");
        });
        const directoryUrl = computedAsync(() => {
            return getUrlPromise("Directory");
        });
        const myFormsUrl = computedAsync(() => {
            return getUrlPromise("MyForms");
        });

        const init = async () => {
            loaded.value = false;
            const widgetData = await getData(
                mainStore,
                "AdminWidget",
                () => mainStore.getUrl("adminWidgetData", { areaUrlSlug: props.settings.areaUrlSlug, areaCode: props.settings.areaCode }),
                async data => {
                    const areaCode = props.settings.areaCode || (await mainStore.getTenantCodeByUrlSlug([props.settings.areaUrlSlug])[props.settings.areaUrlSlug]);
                    return data.AreaCode == areaCode;
                },
            );
            searchWidgetCode.value = widgetData.SearchWidgetCode;
            directoryWidgetCode.value = widgetData.DirectoryWidgetCode;
            guidedSearchWidgetCode.value = widgetData.GuidedSearchWidgetCode;
            myFormsWidgetCode.value = widgetData.MyFormsWidgetCode;
            showMyFormsWidget.value = widgetData.ShowMyFormsWidget;
            loaded.value = true;
        };

        onBeforeMount(async () => {
            await init();
        });
        onActivated(async () => {
            if (isInitialCreate.value) {
                isInitialCreate.value = false;
            } else {
                await init();
            }
        });

        return {
            // States
            searchWidgetCode,
            directoryWidgetCode,
            guidedSearchWidgetCode,
            myFormsWidgetCode,
            showMyFormsWidget,
            loaded,

            // Async Computed
            adminUrl,
            adminSitesUrl,
            guidedSearchUrl,
            searchUrl,
            directoryUrl,
            myFormsUrl,
        };
    },
    components: {
        LoadingPlaceholder,
    },
});
</script>
